import React from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const FeatureUser = ({ platform }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const data = [
    {
      icn: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 56 56"
          fill="none"
        >
          <g clip-path="url(#clip0_0_1587)">
            <path
              d="M28.2891 15.743L34.3113 18.9094L33.161 12.2033L38.0362 7.45227L31.3004 6.47413L28.2891 0.360352L25.2778 6.47413L18.542 7.45227L23.4172 12.2033L22.2669 18.9094L28.2891 15.743Z"
              fill="#E8307A"
            />
            <path
              d="M48.6359 17.3882L45.6246 11.2861L42.6133 17.3882L35.8809 18.3663L40.7527 23.1162L39.6024 29.8235L45.6246 26.6571L51.6502 29.8235L50.4965 23.1162L55.684 18.3663L48.6359 17.3882Z"
              fill="#E8307A"
            />
            <path
              d="M6.082 23.1162L4.9283 29.8235L10.9539 26.6571L16.9761 29.8235L15.8258 23.1162L20.6976 18.3663L13.9652 17.3882L10.9539 11.2861L7.94255 17.3882L0.894531 18.3663L6.082 23.1162Z"
              fill="#E8307A"
            />
            <path
              d="M36.3152 30.9652C36.3152 26.5402 32.7144 22.9395 28.2894 22.9395C23.8644 22.9395 20.2637 26.5402 20.2637 30.9652C20.2637 35.3902 23.8644 38.9909 28.2894 38.9909C32.7144 38.9909 36.3152 35.3902 36.3152 30.9652Z"
              fill="#E8307A"
            />
            <path
              d="M17.0527 50.2268V55.1492H39.5248V50.2268C39.5248 44.0319 34.4836 38.9907 28.2888 38.9907C22.0939 38.9907 17.0527 44.0319 17.0527 50.2268Z"
              fill="#E8307A"
            />
            <path
              d="M52.3663 53.4369C52.3663 49.0118 48.7656 45.4111 44.3405 45.4111C43.5104 45.4111 42.7253 45.5742 41.9717 45.8091C42.4261 47.2102 42.7354 48.6762 42.7354 50.2266V55.149H52.3663V53.4369Z"
              fill="#E8307A"
            />
            <path
              d="M50.7611 38.9909C50.7611 35.45 47.8815 32.5703 44.3405 32.5703C40.7996 32.5703 37.9199 35.45 37.9199 38.9909C37.9199 39.1953 37.9613 39.3884 37.9801 39.5878C39.5631 41.0308 40.8397 42.7918 41.6598 44.8062C42.4783 45.1854 43.3808 45.4115 44.3405 45.4115C47.8815 45.4115 50.7611 42.5318 50.7611 38.9909Z"
              fill="#E8307A"
            />
            <path
              d="M18.5984 39.5878C18.6172 39.3884 18.6586 39.1953 18.6586 38.9909C18.6586 35.45 15.7789 32.5703 12.238 32.5703C8.69704 32.5703 5.81738 35.45 5.81738 38.9909C5.81738 42.5318 8.69704 45.4115 12.238 45.4115C13.1977 45.4115 14.1002 45.1854 14.9187 44.8066C15.7388 42.7918 17.0154 41.0308 18.5984 39.5878Z"
              fill="#E8307A"
            />
            <path
              d="M4.21191 53.4369V55.149H13.8428V50.2266C13.8428 48.6762 14.1521 47.2102 14.6065 45.8091C13.8528 45.5742 13.0678 45.4111 12.2377 45.4111C7.81263 45.4111 4.21191 49.0118 4.21191 53.4369Z"
              fill="#E8307A"
            />
          </g>
          <defs>
            <clipPath id="clip0_0_1587">
              <rect
                width="54.7891"
                height="54.7891"
                fill="white"
                transform="translate(0.894531 0.360352)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      label: t("dashboard.totalUsers"),
      value: platform?.totalUsers || 0,
      // redirectPath: "/manage-user",
    },
    {
      icn: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 56 56"
          fill="none"
        >
          <g clip-path="url(#clip0_0_1587)">
            <path
              d="M28.2891 15.743L34.3113 18.9094L33.161 12.2033L38.0362 7.45227L31.3004 6.47413L28.2891 0.360352L25.2778 6.47413L18.542 7.45227L23.4172 12.2033L22.2669 18.9094L28.2891 15.743Z"
              fill="#E8307A"
            />
            <path
              d="M48.6359 17.3882L45.6246 11.2861L42.6133 17.3882L35.8809 18.3663L40.7527 23.1162L39.6024 29.8235L45.6246 26.6571L51.6502 29.8235L50.4965 23.1162L55.684 18.3663L48.6359 17.3882Z"
              fill="#E8307A"
            />
            <path
              d="M6.082 23.1162L4.9283 29.8235L10.9539 26.6571L16.9761 29.8235L15.8258 23.1162L20.6976 18.3663L13.9652 17.3882L10.9539 11.2861L7.94255 17.3882L0.894531 18.3663L6.082 23.1162Z"
              fill="#E8307A"
            />
            <path
              d="M36.3152 30.9652C36.3152 26.5402 32.7144 22.9395 28.2894 22.9395C23.8644 22.9395 20.2637 26.5402 20.2637 30.9652C20.2637 35.3902 23.8644 38.9909 28.2894 38.9909C32.7144 38.9909 36.3152 35.3902 36.3152 30.9652Z"
              fill="#E8307A"
            />
            <path
              d="M17.0527 50.2268V55.1492H39.5248V50.2268C39.5248 44.0319 34.4836 38.9907 28.2888 38.9907C22.0939 38.9907 17.0527 44.0319 17.0527 50.2268Z"
              fill="#E8307A"
            />
            <path
              d="M52.3663 53.4369C52.3663 49.0118 48.7656 45.4111 44.3405 45.4111C43.5104 45.4111 42.7253 45.5742 41.9717 45.8091C42.4261 47.2102 42.7354 48.6762 42.7354 50.2266V55.149H52.3663V53.4369Z"
              fill="#E8307A"
            />
            <path
              d="M50.7611 38.9909C50.7611 35.45 47.8815 32.5703 44.3405 32.5703C40.7996 32.5703 37.9199 35.45 37.9199 38.9909C37.9199 39.1953 37.9613 39.3884 37.9801 39.5878C39.5631 41.0308 40.8397 42.7918 41.6598 44.8062C42.4783 45.1854 43.3808 45.4115 44.3405 45.4115C47.8815 45.4115 50.7611 42.5318 50.7611 38.9909Z"
              fill="#E8307A"
            />
            <path
              d="M18.5984 39.5878C18.6172 39.3884 18.6586 39.1953 18.6586 38.9909C18.6586 35.45 15.7789 32.5703 12.238 32.5703C8.69704 32.5703 5.81738 35.45 5.81738 38.9909C5.81738 42.5318 8.69704 45.4115 12.238 45.4115C13.1977 45.4115 14.1002 45.1854 14.9187 44.8066C15.7388 42.7918 17.0154 41.0308 18.5984 39.5878Z"
              fill="#E8307A"
            />
            <path
              d="M4.21191 53.4369V55.149H13.8428V50.2266C13.8428 48.6762 14.1521 47.2102 14.6065 45.8091C13.8528 45.5742 13.0678 45.4111 12.2377 45.4111C7.81263 45.4111 4.21191 49.0118 4.21191 53.4369Z"
              fill="#E8307A"
            />
          </g>
          <defs>
            <clipPath id="clip0_0_1587">
              <rect
                width="54.7891"
                height="54.7891"
                fill="white"
                transform="translate(0.894531 0.360352)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      label: t("dashboard.totalActiveUser", "Active User"),
      value: platform?.activeUser || 0,
      // redirectPath: "/manage-hotel-admin",
    },
    {
      icn: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="45"
          height="45"
          viewBox="0 0 59 55"
          fill="none"
        >
          <path
            d="M29.521 31.486H27.7991V3.45806C27.7991 1.94603 26.5671 0.700012 25.041 0.700012H5.95901C4.44707 0.700012 3.20105 1.94603 3.20105 3.45806V31.486H1.47908C0.69508 31.486 0.0650635 32.116 0.0650635 32.886C0.0650635 33.67 0.69508 34.3 1.47908 34.3H29.521C30.305 34.3 30.935 33.67 30.935 32.886C30.935 32.116 30.305 31.486 29.521 31.486ZM20.435 4.97C20.435 4.73202 20.6311 4.536 20.869 4.536H22.8291C23.0671 4.536 23.2631 4.73202 23.2631 4.97V7.01403C23.2631 7.23799 23.0671 7.43401 22.8291 7.43401H20.869C20.6311 7.43401 20.435 7.23799 20.435 7.01403V4.97ZM20.435 11.396C20.435 11.1581 20.6311 10.962 20.869 10.962H22.8291C23.0671 10.962 23.2631 11.1581 23.2631 11.396V13.44C23.2631 13.678 23.0671 13.86 22.8291 13.86H20.869C20.6311 13.86 20.435 13.678 20.435 13.44V11.396ZM20.435 17.822C20.435 17.584 20.6311 17.388 20.869 17.388H22.8291C23.0671 17.388 23.2631 17.584 23.2631 17.822V19.866C23.2631 20.104 23.0671 20.286 22.8291 20.286H20.869C20.6311 20.286 20.435 20.104 20.435 19.866V17.822ZM14.093 4.97C14.093 4.73202 14.289 4.536 14.527 4.536H16.487C16.725 4.536 16.907 4.73202 16.907 4.97V7.01403C16.907 7.23799 16.725 7.43401 16.487 7.43401H14.527C14.289 7.43401 14.093 7.23799 14.093 7.01403V4.97ZM14.093 11.396C14.093 11.1581 14.289 10.962 14.527 10.962H16.487C16.725 10.962 16.907 11.1581 16.907 11.396V13.44C16.907 13.678 16.725 13.86 16.487 13.86H14.527C14.289 13.86 14.093 13.678 14.093 13.44V11.396ZM14.093 17.822C14.093 17.584 14.289 17.388 14.527 17.388H16.487C16.725 17.388 16.907 17.584 16.907 17.822V19.866C16.907 20.104 16.725 20.286 16.487 20.286H14.527C14.289 20.286 14.093 20.104 14.093 19.866V17.822ZM7.75105 4.97C7.75105 4.73202 7.94707 4.536 8.18505 4.536H10.1311C10.369 4.536 10.5651 4.73202 10.5651 4.97V7.01403C10.5651 7.23799 10.369 7.43401 10.1311 7.43401H8.18505C7.94707 7.43401 7.75105 7.23799 7.75105 7.01403V4.97ZM7.75105 11.396C7.75105 11.1581 7.94707 10.962 8.18505 10.962H10.1311C10.369 10.962 10.5651 11.1581 10.5651 11.396V13.44C10.5651 13.678 10.369 13.86 10.1311 13.86H8.18505C7.94707 13.86 7.75105 13.678 7.75105 13.44V11.396ZM7.75105 17.822C7.75105 17.584 7.94707 17.388 8.18505 17.388H10.1311C10.369 17.388 10.5651 17.584 10.5651 17.822V19.866C10.5651 20.104 10.369 20.286 10.1311 20.286H8.18505C7.94707 20.286 7.75105 20.104 7.75105 19.866V17.822ZM12.553 31.486V26.838C12.553 25.2 13.869 23.884 15.507 23.884C17.1035 23.884 18.461 25.1856 18.461 26.838V31.486H12.553Z"
            fill="#E8307A"
          />
        </svg>
      ),
      label: t("dashboard.totalHotel", "Total Hotels"),
      value: `${platform?.totalHotels || 0}`,
      // redirectPath: "/accounting",
    },
    {
      icn: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 53 55"
          fill="none"
        >
          <path
            d="M21.6104 0.916687H9.38954C4.08121 0.916687 0.916626 4.08127 0.916626 9.3896V21.6104C0.916626 26.9188 4.08121 30.0834 9.38954 30.0834H21.6104C26.9187 30.0834 30.0833 26.9188 30.0833 21.6104V9.3896C30.0833 4.08127 26.9187 0.916687 21.6104 0.916687ZM12.5395 19.7292L9.25829 23.0104C9.03954 23.2292 8.76246 23.3313 8.48538 23.3313C8.20829 23.3313 7.91663 23.2292 7.71246 23.0104L6.61871 21.9167C6.18121 21.4938 6.18121 20.7938 6.61871 20.3709C7.04163 19.9479 7.72704 19.9479 8.16454 20.3709L8.48538 20.6917L10.9937 18.1834C11.4166 17.7604 12.102 17.7604 12.5395 18.1834C12.9625 18.6063 12.9625 19.3063 12.5395 19.7292ZM12.5395 9.52085L9.25829 12.8021C9.03954 13.0209 8.76246 13.1229 8.48538 13.1229C8.20829 13.1229 7.91663 13.0209 7.71246 12.8021L6.61871 11.7084C6.18121 11.2854 6.18121 10.5854 6.61871 10.1625C7.04163 9.7396 7.72704 9.7396 8.16454 10.1625L8.48538 10.4834L10.9937 7.97502C11.4166 7.5521 12.102 7.5521 12.5395 7.97502C12.9625 8.39794 12.9625 9.09794 12.5395 9.52085ZM23.6083 22.2375H15.952C15.3541 22.2375 14.8583 21.7417 14.8583 21.1438C14.8583 20.5459 15.3541 20.05 15.952 20.05H23.6083C24.2208 20.05 24.702 20.5459 24.702 21.1438C24.702 21.7417 24.2208 22.2375 23.6083 22.2375ZM23.6083 12.0292H15.952C15.3541 12.0292 14.8583 11.5334 14.8583 10.9354C14.8583 10.3375 15.3541 9.84169 15.952 9.84169H23.6083C24.2208 9.84169 24.702 10.3375 24.702 10.9354C24.702 11.5334 24.2208 12.0292 23.6083 12.0292Z"
            fill="#E8307A"
          />
        </svg>
      ),
      label: t("dashboard.totalBooking"),
      value: platform?.totalBookings || 0,
      // redirectPath: "/manage-booking",
    },
  ];
  return (
    <>
      <Row className="g-3 py-2">
        {data.map((item, key) => (
          <Col
            key={key}
            lg="3"
            md="4"
            sm="6"
            className="my-2"
            onClick={() => navigate(item.redirectPath)}
            style={{ cursor: "pointer" }}
          >
            <div
              className="cardCstm rounded-lg p-3 d-flex align-items-center h-100"
              style={{
                flexDirection: "row",
                background: "#e8307a21",
                borderRadius: "5px",
              }}
            >
              <div
                className="icnWrp flex-shrink-0"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "50px",
                  height: "50px",
                }}
              >
                {item.icn}
              </div>
              <div className="content" style={{ flex: 1, minWidth: 0 }}>
                <h6
                  className="m-0 fw-bold text-truncate"
                  style={{ fontSize: "14px", color: "#333" }}
                  title={item.label}
                >
                  {item.label}
                </h6>
                <h4
                  className="m-0 fw-bold themeBlue"
                  style={{ fontSize: "20px", color: "#E8307A" }}
                >
                  {item.value}
                </h4>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default FeatureUser;
